import { render, staticRenderFns } from "./NodeExtras.vue?vue&type=template&id=98cb0070"
import script from "./NodeExtras.vue?vue&type=script&lang=js"
export * from "./NodeExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports